var _defs, _ellipse, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHappyFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 481.8 481.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#b7ce3a;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 240.9,
    cy: 240.79,
    rx: 240.9,
    ry: 240.79
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.31,332.56c-29.5,0-57.26-5.77-82.55-17.15-7.74-3.48-11.19-12.58-7.71-20.32,3.48-7.74,12.58-11.19,20.32-7.7,21.61,9.73,45.51,14.57,71.07,14.44,25.91-.15,54.35-6.18,78.03-16.55,7.78-3.4,16.84,.14,20.24,7.92,3.4,7.77-.14,16.84-7.92,20.24-27.77,12.16-59.8,18.95-90.18,19.13-.44,0-.88,0-1.31,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 168.48,
    cy: 194.32,
    rx: 24.59,
    ry: 24.58
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 313.71,
    cy: 194.32,
    rx: 24.59,
    ry: 24.58
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyFilled);
export default __webpack_public_path__ + "static/media/happy-filled.f4cb369423566498f64a11a8c91a9998.svg";
export { ForwardRef as ReactComponent };